import axios from "axios";

const API_BASE_URL = "/api/v1";

export const getAssessmentsByAccountId = async (accountId, disease) => {
    try {
        const response = await axios.get(`${API_BASE_URL}/assessments/${accountId}`, {
            params: disease ? { disease } : undefined,
        });
        return response.data?.assessments || [];
    } catch (error) {
        console.error("Error fetching assessments by account_id:", error);
        throw error;
    }
};